import { withApollo } from './with-apollo-client';

export function bootstrap(PageComponent, { ssr = true } = {}) {
  return withApollo(PageComponent, { ssr });
}
